<template>
    <div>
      <Head>
        <title>{{(category) ? category +' courses in Ireland' : 'Courses in Ireland'}}</title>
        <link rel="canonical" :href="'https://backtoworkconnect.ie/courses/'+category_alias" />
        <meta head-key="description" name="description" :content="'Unlock your potential in ' + category + ' with specializsd courses designed for adult learners in Ireland. Our comprehensive programs cater to diverse skill levels, ensuring a tailored learning experience. Elevate your career and knowledge with expert guidance and flexible study options.'" />

      </Head>
      <v-container class="">
        <v-card>
            <BackButton></BackButton>
            <v-container class="grey lighten-5"  v-if="!expandSearch">
                <v-row>
                    <v-col cols=12 sm="12" lg="12" class="p-0" >
                        <v-text-field 
                            
                            label="Search" 
                            v-model="keywords" 
                            prepend-icon="mdi-magnify" 
                            @focus="expandSearch = true"></v-text-field>
                    </v-col>    
                </v-row>    
            </v-container>
            <template v-if="expandSearch">
                <TabbedSearch  :clearbg="true" startTab="courses" :startOpen="startOpen" :baseurl="baseurl" :locations="locations" :categories="categories" :startKeyword="keywords" :startLocation="location" :startCategory="category"></TabbedSearch>

            </template>
        </v-card>
        
        <h2 class="m-3">Your search for <span v-if="category">{{category}} - </span><span v-if="keywords">"{{keywords}}"</span><span v-else>courses</span> in {{location}} returned {{courses.total}} result(s).</h2>
        <h1 class="m-3">Courses in Ireland</h1>
        <CourseCard :key="j.id" v-for="j in courses.data" :course="j" :auth="auth" :state="state" :baseurl="baseurl" :prevurl="prevurl" 
        @toggleComponentLogin="toggleComponentLogin($event)">
        </CourseCard>
        <br/><br/>
        <Pagination :links="courses.links"></Pagination>
      </v-container>
      
    </div>
</template>
<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import CourseCard from '@/Shared/CourseCard'
  import axios from 'axios'
  import Pagination from '@/Shared/Pagination'

  import TabbedSearch from '@/Shared/TabbedSearch'

  import BackButton from '@/Shared/BackButton'

  export default {
    props: {
      category_alias: String,
      courses: Object,
      auth: Object,
      state: String,
      baseurl: String,
      prevurl: String,
      location: String,
      category: String,
      categories: Array,
      keywords: String,
      locations: Array,
      startOpen: Boolean
    },
    components: {
      Head,
      CourseCard,
      Pagination,
      BackButton,
      TabbedSearch
    },
    layout: Layout,
    data() {
        return {
            applyDialog: false,
            expandSearch: this.startOpen,
            search: {
                location: '',
                category: '',
                keywords: '',
            }
        }
    },
    watch: {
    },
    created() {
        if (this.keywords)
            this.search.keywords = this.keywords
    },
    mounted() {
        this.search.keywords = (!this.keywords || this.keywords =='courses') ? '' : this.keywords
        this.search.location = (!this.location || this.location=='Ireland') ? '' : this.location
        this.search.category = this.category
    },
    methods: {
        toggleComponentLogin(e) {
            console.log('results triggering login',e)
            if (!this.auth.user)
                this.$parent.$emit('toggleComponentLogin',e);
        
        },
        searchCourses() {
            this.$inertia.get(this.baseurl+'/search/course', {keyword: this.search.keywords, location: this.search.location, category: this.search.category}, {

            }) 
        }
    },
  }
  </script>
  
  <style>
    .fixedFooter {
        margin-top:50px;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }
    </style>